import { CompanyType } from "@/types/auth";
import { BedType } from "@/types/form";
import { PaymentMethod } from "@/types/reservation";

export const authQueryKeys = {
  all: ["auth"] as const,
  user: () => [...authQueryKeys.all, "me"] as const
};

export const reservationQueryKeys = {
  all: ["reservation"] as const,
  reservationEligibility: () => [...reservationQueryKeys.all, "reservationEligibility"] as const,
  serviceSchedules: (type: CompanyType) => [...reservationQueryKeys.all, "serviceSchedules", type] as const,
  startupCheckInOutDates: () => [...reservationQueryKeys.all, "startupCheckInOutDates"] as const,
  partnerAvailableStayDates: () => [...reservationQueryKeys.all, "partnerAvailableStayDates"] as const,
  partnerCheckInOutDates: (numOfGuests: number) =>
    [...reservationQueryKeys.all, "partnerCheckInOutDates", numOfGuests] as const,
  checkInDates: () => [...reservationQueryKeys.all, "checkInDates"] as const,
  stayWeeks: (checkInDate: string) => [...reservationQueryKeys.all, "stayWeeks", checkInDate] as const,
  checkoutDates: (checkInDate: string, stayWeeks: number) =>
    [...reservationQueryKeys.all, "checkoutDates", checkInDate, stayWeeks] as const,
  desiredRoomType: (
    checkInDate: string,
    checkoutDate: string,
    totalGuests: number,
    bunkerBedPreference: BedType,
    stayWeeks?: number
  ) =>
    [
      ...reservationQueryKeys.all,
      "desiredRoomType",
      checkInDate,
      checkoutDate,
      totalGuests,
      bunkerBedPreference,
      stayWeeks
    ] as const,
  availableRooms: (checkInDate: string, stayWeeks?: number, checkOutDate?: string) =>
    [...reservationQueryKeys.all, "availableRooms", checkInDate, stayWeeks, checkOutDate] as const,
  preOccupancy: () => [...reservationQueryKeys.all, "preOccupancy"] as const,
  nationality: () => [...reservationQueryKeys.all, "nationality"] as const,
  reservationLimit: () => [...reservationQueryKeys.all, "reservationLimit"] as const,
  maruRefundDetailInfo: (reservationCode: string) =>
    [...reservationQueryKeys.all, "maruRefundDetailInfo", reservationCode] as const
};

export const mypageQueryKeys = {
  all: ["mypage"] as const,
  reservationHistoryListAll: () => [...mypageQueryKeys.all, "reservationHistoryList"] as const,
  reservationHistoryList: ({ year, membershipId }: { year?: number; membershipId?: string }) =>
    [...mypageQueryKeys.all, "reservationHistoryList", year, membershipId] as const,
  membershipList: () => [...mypageQueryKeys.all, "membershipList"] as const,
  reservationDetailAll: () => [...mypageQueryKeys.all, "reservationDetail"] as const,
  reservationDetail: (reservationCode: string) =>
    [...mypageQueryKeys.all, "reservationDetail", reservationCode] as const,
  reservationPaymentDetail: () => [...mypageQueryKeys.all, "reservationPaymentDetail"] as const,
  partnerReservationPaymentDetail: ({
    method,
    numOfGuests,
    checkInDate,
    checkOutDate
  }: {
    method: PaymentMethod;
    numOfGuests: number;
    checkInDate: string;
    checkOutDate: string;
  }) =>
    [
      ...mypageQueryKeys.all,
      "partnerReservationPaymentDetail",
      method,
      numOfGuests,
      checkInDate,
      checkOutDate
    ] as const,
  partnerReservationPaymentDetailAll: () => [...mypageQueryKeys.all, "partnerReservationPaymentDetail"] as const
};
